module.exports = __webpack_public_path__ + "img/teamwork-build-app@2x.12983139.png";